import { Text, Tag, Flex, Icon, Box } from '@chakra-ui/react';
import { CellValue } from 'react-table';

import { IconBill } from 'assets/icons';

const convertDateToPdfName = (dateString: string) => {
  let date = new Date(dateString);
  // Check for invalid date
  if (isNaN(date.getTime())) {
    date = new Date(dateString.split('/').reverse().join('/'));
  }

  const pdfName: string =
    ['Invoice', date.toLocaleDateString('default', { month: 'long' }), date.getDate()].join('-') + '.pdf';
  return pdfName;
};

export const getTransactionsColumns = (t: any) => {
  return [
    // {
    //   id: 'selection',
    //   width: 30,
    //   Header: ({ getToggleAllRowsSelectedProps }: any) => {
    //     return <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} colorScheme="secondary" />;
    //   },
    //   Cell: ({ row }: any) => {
    //     return <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} colorScheme="secondary" />;
    //   },
    // },
    // {
    //   Header: <Text textTransform="uppercase">{t('accountBilling:invoiceNo')}</Text>,
    //   accessor: 'invoiceNumber',
    //   width: 150,
    //   enableSort: false,
    //   Cell: (data: CellValue) => {
    //     return <Text>{data.row.original?.invoice_number}</Text>;
    //   },
    // },
    {
      Header: <Text textTransform="uppercase">{t('common:subscription')}</Text>,
      accessor: 'subscription',
      width: 150,
      enableSort: false,
      Cell: (data: CellValue) => {
        return (
          <Box>
            <Text>{data.row.original?.plan}</Text>
            {/* <Text fontSize="xs">{data.row.original?.plan_description}</Text> */}
          </Box>
        );
      },
    },
    {
      Header: <Text textTransform="uppercase">{t('accountBilling:startBillingPeriod')}</Text>,
      accessor: 'startBillingDate',
      width: 150,
      enableSort: false,
      Cell: (data: CellValue) => {
        return (
          <Box>
            <Text>{data.row.original?.periods?.start}</Text>
          </Box>
        );
      },
    },
    {
      Header: <Text textTransform="uppercase">{t('accountBilling:endBillingPeriod')}</Text>,
      accessor: 'endBillingDate',
      width: 150,
      enableSort: false,
      Cell: (data: CellValue) => {
        return (
          <Box>
            <Text>{data.row.original?.periods?.end}</Text>
          </Box>
        );
      },
    },
    {
      Header: <Text textTransform="uppercase">{t('common:status')}</Text>,
      accessor: 'status',
      width: 150,
      enableSort: false,
      Cell: (data: CellValue) => {
        // Caveat for the dates that Stripe is returning as Thurs, Jan 01, 1970
        if (new Date(data.row.original?.payment_date).getTime() === 21600000 && data.row.original?.status === 'open')
          return (
            <Tag bg="rgba(250, 86, 86, 0.8)" color="newGray.1000" fontWeight={600}>
              {t('common:unpaid')}
            </Tag>
          );

        switch (data.row.original?.status) {
          case 'paid':
            return (
              <Tag bg="rgba(39, 174, 96, 0.5)" color="newGray.1000" fontWeight={600}>
                {t('common:paid')}
              </Tag>
            );
          case 'uncollectible':
            return (
              <Tag bg="rgba(250, 86, 86, 0.8)" color="newGray.1000" fontWeight={600}>
                {t('common:unpaid')}
              </Tag>
            );
          case 'draft':
            return (
              <Tag bg="rgba(255, 223, 168, 1)" color="newGray.1000" fontWeight={600}>
                {t('common:draft')}
              </Tag>
            );
          case 'open':
            return (
              <Tag bg="rgba(255, 223, 168, 1)" color="newGray.1000" fontWeight={600}>
                {t('common:pending')}
              </Tag>
            );
          case 'void':
            return (
              <Tag bg="rgba(72, 82, 175, 0.8)" color="newGray.1000" fontWeight={600}>
                {t('common:void')}
              </Tag>
            );
          default:
            return (
              <Tag bg="rgba(250, 86, 86, 0.8)" color="newGray.1000" fontWeight={600}>
                {t('common:pending')}
              </Tag>
            );
        }
      },
    },
    {
      Header: <Text textTransform="uppercase">{t('common:total')}</Text>,
      accessor: 'total',
      width: 150,
      enableSort: false,
      Cell: (data: CellValue) => {
        const paymentDisplay: string =
          (data.row.original?.payment_amount as number) >= 0
            ? '$' + data.row.original?.payment_amount?.toFixed(2)
            : '($' + Math.abs(data.row.original?.payment_amount)?.toFixed(2) + ')';
        return <Text fontWeight={600}>{paymentDisplay}</Text>;
      },
    },
    {
      Header: <Text textTransform="uppercase">{t('accountBilling:downloadInvoice')}</Text>,
      accessor: 'downloadInvoice',
      width: 100,
      enableSort: false,
      Cell: (data: CellValue) => {
        return (
          <a href={data.row.original?.invoice_pdf_link}>
            <Flex
              sx={{
                color: 'secondary.500',
                alignItems: 'center',
                borderBottom: '1px solid',
                borderColor: 'transparent',
                _hover: {
                  borderColor: 'secondary.500',
                },
              }}
              title="Download invoice"
            >
              <Icon as={IconBill} mr={1} />
              <Text>
                {data.row.original?.status === 'open'
                  ? 'Invoice-Unpaid'
                  : convertDateToPdfName(data.row.original?.payment_date || null)}
              </Text>
            </Flex>
          </a>
        );
      },
    },
  ];
};
